import { useCartKeyContext } from '@/features/pos/components/Cart/contexts/CartKey'
import { ContainerItem } from '@/features/pos/components/Cart/parts/Overview/parts/CartContainerItem/types'
import { CartProductItem } from '@/features/pos/components/Cart/parts/Overview/parts/CartItem/types'
import { CartQuery } from '@/features/pos/components/Cart/queries'
import {
    transformCartContainerItemToContainerItem,
    transformCartItemToProductItem,
} from '@/features/pos/components/Cart/utils/transforms'
import { usePosMode } from '@/features/pos/contexts/PosMode'
import { useHandleQueryErrorWithToast } from '@/features/pos/hooks/useHandleQueryErrorWithToast'
import { useQuery } from '@apollo/client'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface CartItems {
    items: CartProductItem[]
    containerItems: ContainerItem[]
    loaded: boolean
}

export const useCartItems = (): CartItems => {
    const mode = usePosMode()

    const { cartKey, mode: cartKeyMode } = useCartKeyContext()

    const skip = !cartKey || mode !== cartKeyMode

    const { data, error, loading } = useQuery(CartQuery, { skip, variables: { cartKey: cartKey! } })

    useHandleQueryErrorWithToast(error, loading)

    const { t } = useTranslation()
    const loaded = !skip && !loading && !error

    return useMemo(
        () => ({
            items: data?.cart.items.map((item) => transformCartItemToProductItem(item, t)) ?? [],
            containerItems:
                data?.cart.containerItems.map((item) =>
                    transformCartContainerItemToContainerItem(item, t)
                ) ?? [],
            loaded,
        }),
        [data?.cart.containerItems, data?.cart.items, loaded, t]
    )
}
